const DocumentTitleFormatter = title => {
  return `${title} | HIMSS Survey Builder`;
};

export default DocumentTitleFormatter;
